(function() {
  'use strict';

  angular.module('app').controller('FeedbackListController', FeedbackListController);

  FeedbackListController.$inject = [
    '$rootScope',
    '$scope',
    '$routeParams',
    '$location',
    '$filter',
    '$timeout',
    'blockUI',
    'NewsService',
    'CouponsService',
    'LANGS',
    'SelectService',
    'SettingsService',
    'FeedbackService',
    'CustomerService',
    '$q'
  ];

  function FeedbackListController(
      $rootScope,
      $scope,
      $routeParams,
      $location,
      $filter,
      $timeout,
      blockUI,
      NewsService,
      CouponsService,
      LANGS,
      SelectService,
      SettingsService,
      FeedbackService,
      CustomerService,
      $q) {

    $scope.isPageMode = isPageMode;
    $scope.getFiltersList = SelectService.getLList;
    $scope.attachmentList = [];
    $scope.isSourceRouteView = false;

    $scope.params = {
      page: 1,
      count: 20,
      date_from: moment().startOf('day').subtract(1, 'month').utc().toDate(),
      date_to: moment().endOf('day').utc().toDate(),
      sort_by_rating: ''
    };
    $scope.summary = {};
    $scope.pager_count = [10, 20, 50, 100, 200];
    $scope.getPages = getTotalPaginatedPages;

    $scope.data = {
      showOnlyUnreaded: false
    };
    var block_feedbacks_list = blockUI.instances.get('block_feedbacks_list');
    var feedback_attachment_preview = blockUI.instances.get('feedback_attachment_preview');

    $scope.searchCustomerField = {
      searchText: '',
      onCustomerFieldSelect: function($item) {
        $scope.searchCustomerField.searchCustomer = $item;
        delete $scope.searchCustomerField.searchText;
      },
      getSearchCustomers: function(val) {
        return new Promise(function(resolve) {
          var params = {
            search_text: val,
            customer_type: 'customer',
            page: 1,
            count: 5
          };
          CustomerService.AllTypeCustomers(params, function(success, data) {
            if (success) {
              resolve(data.data);
            }
          });
        });
      }
    };

    $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
    SettingsService.GetPlatformSupportedLanguages(function(success, response) {
      $scope.platformSupportedLanguagesCodes = response;
    });

    initController();

    $scope.getRatingHeaderClass = function() {
      switch ($scope.params.sort_by_rating) {
        case '':
          return {'sorting': true};
        case 'asc':
          return {'sorting_asc': true};
        case 'desc':
          return {'sorting_desc': true};
      }
    };

    $scope.onRatingSortOrderChange = function() {
      $scope.params.sort_by_rating = $scope.params.sort_by_rating === 'asc' ? 'desc' : 'asc';
      getFeedbackList();
    };

    function isPageMode(mode) {
      return mode == $scope._pageMode;
    }

    function isRouteMode(mode) {
      return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
    }

    function initPageMode() {
      $scope._pageMode = 'show';
      if (isRouteMode('preview')) {
        $scope._pageMode = ($routeParams.hasOwnProperty('feedback_id')) ? 'preview' : 'show';
      } else if (isRouteMode('create')) {
        $scope._pageMode = 'create';
      }

      switch ($scope._pageMode) {
        case 'show':
          _doShow();
          break;
        case 'preview':
          getCustomerFeedback($routeParams.feedback_id);
          break;
      }
    }

    function _doShow() {
      getFeedbackSourcesList();
      getFeedbackList();
    }

    function initController() {
      initPageMode();
    }

    function getFeedbackList() {
      block_feedbacks_list.start();
      var params = angular.copy($scope.params);

      params.date_from = moment(params.date_from);
      params.date_to = moment(params.date_to);
      params = dateFieldsFormat(params, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]', false);

      if ($rootScope.ENV.filters.feedback_list && $rootScope.ENV.filters.feedback_list.filter.id &&
          $rootScope.ENV.filters.feedback_list.filter.id != 0 || $scope.data.feedback_source_id) {
        params.loyalty_id = $rootScope.ENV.filters.feedback_list.filter.id;
      }

      if ($routeParams.feedback_source_id || $scope.data.feedbackSource && $scope.data.feedbackSource.id !== '0') {
        params.feedback_source_id = $routeParams.feedback_source_id || $scope.data.feedbackSource.id;
        $scope.isSourceRouteView = !!$routeParams.feedback_source_id;
      }

      if ($scope.searchCustomerField.searchCustomer) {
        params.user_id = $scope.searchCustomerField.searchCustomer.id;
      }
      FeedbackService.getFeedbackList(params, function(success, response) {
        if (success) {
          $scope.summary = response.summary;
          $scope.data.feedbackList = response.data;
        }
        block_feedbacks_list.stop();
      });
    }

    function getFeedbackSourcesList() {
      if ($scope.data.currentFilter && $scope.data.currentFilter.id) {
        FeedbackService.getFeedbackSources($rootScope.ENV.filters.feedback_list.filter.id, {
          page: 1,
          count: 20,
          only_active: false
        }, function(success, response) {
          if (success) {
            $scope.data.feedbackSourcesList = response.data;
            $scope.data.feedbackSourcesList.unshift({
              title: $filter('translate')('Feedback-list filter#feedback-source#all-sources'),
              id: '0',
              active: 1
            });
            if (!$scope.data.feedbackSource) {
              $scope.data.feedbackSource = $scope.data.feedbackSourcesList[0];
            }

          }
        });
      }
    }

    $scope.toogleFeedbackReaded = function(feedback_id, data, makeReaded) {
      if (makeReaded) {
        data.readed = 1;
      } else {
        data.readed = data.readed ? 0 : 1;
      }

      FeedbackService.markFeedbackReaded(feedback_id, data, function(success, response) {
        if (success) {
          getFeedbackList();
        }
      });
    };

    $scope.deleteFeedback = function(feedback_id) {
      FeedbackService.removeCustomerFeedback(feedback_id, function(success, response) {
        if (success) {
          getFeedbackList();
        }
      });
    };

    $scope.updateFeedbackList = function() {
      _doShow();
    };

    function getCustomerFeedback(feedback_id) {
      FeedbackService.getFeedbackInfo(feedback_id, function(success, response) {
        if (success) {
          $scope.feedbackData = response;
          var attachmentsPromiseList = [];

          if (response.attached_files_exists) {
            feedback_attachment_preview.start();
            response.attached_files.forEach(function(item) {
              attachmentsPromiseList.push(getFeedbackAttachment(feedback_id, item.id, item.type));
            });
          }

          if (attachmentsPromiseList && attachmentsPromiseList.length) {
            // var deferred = $q.defer();
            // var promise = deferred.promise;
            $q.all(attachmentsPromiseList).then(function(results) {
              feedback_attachment_preview.stop();
            });
          }

          // make feedback readed when user come to read it
          if ($scope.feedbackData.readed === 0) {
            $scope.toogleFeedbackReaded($scope.feedbackData.id, $scope.feedbackData, true);
          }
        }
      });
    }

    function getFeedbackAttachment(feedback_id, attachment_id, type) {
      var defer = $q.defer();
      FeedbackService.getFeedbackAttachment(feedback_id, attachment_id, function(success, response) {
        if (success) {
          var fileReader = new window.FileReader();
          fileReader.readAsBinaryString(response);

          if (type === 'picture') {
            fileReader.onload = function(e) {
              $scope.$apply(function() {
                $scope.attachmentList.push({
                  data: 'data:' + response.type + ';base64,' + btoa(fileReader.result),
                  type: type,
                  typeToShow: response.type
                });
              });
            };
          } else if (type === 'video') {
            fileReader.onload = function(e) {
              $scope.$apply(function() {
                $scope.attachmentList.push({
                  data: 'data:' + response.type + ';base64,' + btoa(fileReader.result),
                  type: type,
                  typeToShow: response.type
                });
              });
            };
          } else if (type === 'voice') {
            fileReader.onload = function(e) {
              $scope.$apply(function() {
                $scope.attachmentList.push({
                  data: 'data:' + response.type + ';base64,' + btoa(fileReader.result),
                  type: type,
                  typeToShow: response.type
                });
              });
            };
          } else {

          }
          defer.resolve();
        }
        defer.reject();
      });
      return defer.promise;
    }

    $scope.pageChange = function() {
      getFeedbackList();
    };

    $scope.onCountChange = function(count) {
      $scope.params.page = 1;
      $scope.params.count = count;
      getFeedbackList();
    };

    $rootScope.$watch('L_LIST', function(newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        $scope.data.filtersList = angular.copy($rootScope.L_LIST);

        if ($rootScope.ENV.filters.feedback_list && $rootScope.ENV.filters.feedback_list.filter &&
            $rootScope.ENV.filters.feedback_list.filter.id !== '0') {
          $scope.data.currentFilter = $rootScope.ENV.filters.feedback_list.filter;
        } else {
          for (var i in $scope.data.filtersList)
            if ($scope.data.filtersList[i].id === '0')
              $scope.data.currentFilter = $scope.data.filtersList[i];
        }
      }
    });

    $scope.$watch('data.currentFilter', function(newValue, oldValue) {
      if (newValue) {
        var l = $rootScope.ENV.filters.feedback_list;
        if (l)
          l.filter = newValue;
        else
          l = {filter: newValue};

        if ($scope.data.feedbackSourcesList) {
          $scope.data.feedbackSource = $scope.data.feedbackSourcesList[0];
        }

        $rootScope.ENV.filters.feedback_list = l;
        $rootScope.storeENV();
        _doShow();
      }
    }, true);

    $scope.$watch('data.feedback_source_id', function(newValue, oldValue) {
      if (newValue) {
        _doShow();
      }
    }, true);

    $scope.onCancelEdit = function() {
      $location.path('/feedbacks');
    };
  }
})();
